import {Component, ElementRef, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {forkJoin, Observable, of, Subject} from 'rxjs';
import {first, map, mergeMap, takeUntil, tap} from 'rxjs/operators';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {CompanyService, EmployeeService, IResponse, EventService} from '../../../../../core/services';
import {Employee} from '../../employee/employee';
import {
  AutocalCheckboxList,
  CalType, COLORLIST,
  ColumnInput,
  CustomReadOnlyCols,
  EXPENDITURECOLUMNS,
  EXPENSE,
  expenseHasChanged,
  INCOME,
  INCOMECOLUMNS,
  listHasTime,
  listNestedHasTimeHeaderSetting,
  PayrollColumnDataValue,
  PayrollColumnFooter,
  PayrollColumnHeader, PayrollStatus,
  SpecialColumnPayroll,
  SpecialExtendColumns,
  TotalWorkDay,
  TotalWorkHour,
} from '../payroll';
import {
  AddHocCheckbox,
  autoCalColumnList,
  autoCalPvdExpenseColumn,
  DataSets,
  ENDDATEEXPENSELIST,
  ENDDATEINCOMELIST,
  EXPENSELIST,
  INCOMELIST, pvdStlColumn,
  RadioItem,
  RecalType
} from '../../../../../shared/components/payroll-checklist/checklist';
import {
  formatDatePickerTo,
  formatDecimalPrice,
  getArrayDiff,
  getDisplayMonthTH,
  getExpenditureLocalStorage,
  getIncomeLocalStorage, IsEmptyValue,
  numberWithoutCommas,
  setExpenditureLocalStorage,
  setIncomeLocalStorage
} from '../../../../../shared/utils/utils';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import _, {cloneDeep, conforms, intersection, set, uniq} from 'lodash';
import {reorderColumns} from '../../../../../shared/utils/utils-table';
import {environment} from 'src/environments/environment';
import { PAGE_LIMIT } from '../../payroll';
import { LeavePageConfirmModalComponent } from 'src/app/shared/components/leave-page-confirm-modal/leave-page-confirm-modal.component';

@Component({
  selector: 'itax-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss'],
  animations: [
    trigger('tabState', [state('default', style({
      transform: 'translateX(0)'
    })),
      state('open', style({
        right: '0px',
        top: '51px'
      })),
      transition('default <=> open', animate(200))
    ])
  ]
})

export class StepOneComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  @ViewChild('wrapMiniProfile') wrapMiniProfile: ElementRef;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  @ViewChild('contentAutoCal') contentAutoCal: TemplateRef<any>;
  @ViewChild('contentPayDate') contentPayDate: TemplateRef<any>;
  @ViewChild('contentWarning') contentWarning: TemplateRef<any>;
  @ViewChild('progressModal') progressModal: ElementRef;
  @ViewChild('confirmReportModal') confirmReportModal: ElementRef;

  environment = environment;

  state = 'default';
  employeeData: Employee;
  employeeId: string;
  employeeDeductionData: any;
  incomeColumns: string[];
  expenditureColumns: string[];
  employeeList: any[] = [];
  employeeCurrent: any[] = [];
  employeeOld: any[] = [];
  employeeTempList: any[] = [];
  employeeRemoved: any[] = [];
  incomeColumnsHeader: PayrollColumnHeader[];
  incomeColumnsData: PayrollColumnDataValue[];
  expenditureColumnsHeader: PayrollColumnHeader[];
  expenditureColumnsData: PayrollColumnDataValue[];
  incomeFooter: PayrollColumnFooter[];
  expenseFooter: PayrollColumnFooter[];
  summaryFooter: PayrollColumnFooter[];
  totalData: PayrollColumnDataValue[];
  filteredemployees: Employee[];
  isLoading: boolean;
  expenseHasChanged: any[] = [];
  timeUnitPriceHasChanged: any[] = [];
  incomeColumnsNoFormat: any[];
  expenseColumnsNoFormat: any[];
  updateRecalType: string[] = [];
  autoCalColumn: string[] = [];
  selectedEmployee: number[] = [];
  defaultPndStl: any[] = [];
  defaultIncome: any[];
  defaultColumns: any;
  requestNotiList: any[] = [];
  requestNotiDetail: any;
  hasRequestNoti: boolean;

  companyId: string;
  payrollId: string;
  month: number;
  displayMonthTH: string;
  year: number;
  modalRef: BsModalRef;
  minDate: any;
  payrollStatus: string;

  arr = [];
  copyLength = 0;
  canRedirect = false;
  isAllExpenseEmpty = false;
  payDate = null;
  autocalCheckboxList = AutocalCheckboxList;
  canAutocal = true;
  colorList = COLORLIST;
  bgColor: string;
  setNocalWht = false;
  actionName = '';
  partTime = 'Part-time';
  progress: number = 0;
  isExcelLoading: boolean = false;
  excelLoadingCollection = {};
  isLoadingSpin = false;
  defaultExpense = [];
  employeeListData = [];
  isProceedData = false;
  searchName: string;
  isAutoRecalColumn = false;

  page: number = 1;
  pageTotal: number = 1;
  totalEmployee: number;
  startRowIndex: number;

  employeeCaches: any[] = [];

  filters: any;

  allIncomeList = INCOMELIST.concat(ENDDATEINCOMELIST);
  allExpenseList = EXPENSELIST.concat(ENDDATEEXPENSELIST);

  timeClockColumn: any;
  installment: number;
  isInstallment: boolean;

  percentage = 0;

  selectedReportOption: any
  reportOptions: RadioItem[] = []

  extendColumns = [{
    labelEn: 'remark',
    title: 'หมายเหตุ',
    type: 'text',
    width: 250,
    wordWrap: false,
    maxlength: 250,
  }]
  extendData: PayrollColumnDataValue[]

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private modalService: BsModalService,
    private employeeService: EmployeeService,
    private eventService: EventService,
  ) {
  }

  ngOnInit(): void {
    this.route.queryParams
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(this.getData.bind(this));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    document.body.removeAttribute('style')
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return this.canRedirect;
  }

  getData(params: Params): void {
    this.reportOptions = [{
      label: 'ภาษาไทย',
      value: 'th',
      checked: false
    }, {
      label: 'English',
      value: 'en',
      checked: false
    }];

    this.setDefaultData(params);
    if (this.payrollStatus === PayrollStatus.init) {
      this.loadData();
    } else {
      this.loadExistingData();
    }
  }

  loadData(): void {
    this.isLoading = true;
    this.getSelectedPayroll();
    const body = {
      companyId: this.companyId,
      paid: true,
      month: this.month,
      year: this.year,
      installment: this.installment,
      incomeColumns: this.generateColumnInput(this.incomeColumns),
      expenseColumns: this.generateColumnInput(this.expenditureColumns)
    };

    this.incomeColumns = this.incomeColumns.filter(item => !item.includes('_autoFetch'))
    this.expenditureColumns = this.expenditureColumns.filter(item => !item.includes('_autoFetch'))
    this.expenditureColumns = this.addSpecialExtendColumns(this.expenditureColumns, false)

    setIncomeLocalStorage(this.incomeColumns)
    setExpenditureLocalStorage(this.expenditureColumns)

    this.companyService.generateNewPayroll(body).pipe(
      takeUntil(this.destroy$)
    ).subscribe((res1: IResponse) => {
      if (res1.success) {
        this.eventService
          .getServerSentEvent(`${environment.apiBaseUrl}/companies/${this.companyId}/payroll/${res1.data.progressId}/createpayroll`)
          .subscribe((res2: any) => {
            if (res2.type === 'id') {
              this.getCompletedPayrollDetailByMonth(res2.data, {}, true);
            } else {
              if (res2.data !== 'connecting') {
                this.progress = +res2.data;
              }
            }
          });
        }
    });
  }

  generateColumnInput(columns: string[]): ColumnInput[] {
    var output: ColumnInput[] = []
    for (let k of columns) {
      if (k.includes('_autoFetch')) {
        var name = k.replace('_autoFetch', '')
        var index = output.findIndex((o => o.name == name))
        if (index < 0) {
          output.push({ name: name, autoFetch: true })
        } else {
          output[index].autoFetch = true
        }
      } else {
        var index = output.findIndex((o => o.name == k))
        if (index < 0) {
          output.push({ name: k, autoFetch: false })
        }
      }
    }
    return output
  }

  getCompletedPayrollDetailByMonth(payrollId: string = null, filter: any = {}, isLoadColumns = false) {
    this.expenseHasChanged = [];
    payrollId = payrollId || this.payrollId;
    this.companyService.getCompletedPayrollDetailByMonth(this.companyId, payrollId, this.page, PAGE_LIMIT, filter, null).pipe(
      takeUntil(this.destroy$)
    ).subscribe((response: IResponse) => {
      if (this.scrollContainer?.nativeElement) {
        this.scrollContainer.nativeElement.scrollTop = 0;
      }
      const data = response.data;
      this.buildData(data, isLoadColumns);
      if (isLoadColumns) {
        this.companyService.checkDefaultColumns(this.companyId, {
          month: this.month,
          year: this.year,
          installment: this.installment
        }).pipe(
          takeUntil(this.destroy$)
        ).subscribe((res: any) => {
          this.defaultColumns = res.column;
          this.defaultIncome = res.column.income ? res.column.income.filter(i => i.isDefault && !i.editable && i.isChecked) : [];
          this.defaultPndStl = res.column.expense ? res.column.expense.filter(i => i.isDefault && !i.editable && i.isChecked) : [];
        });
      }
      this.progress = 100;
    });
  }

  loadExistingData(): void {
    this.isLoading = true;
    const body = {
      companyId: this.companyId,
      payrollId: this.payrollId
    };
    this.companyService.getEditPayroll(body).pipe(
      takeUntil(this.destroy$),
      mergeMap(_ => {
        return this.companyService.getCompletedPayrollDetailByMonth(this.companyId, this.payrollId, this.page, PAGE_LIMIT, this.filters, null);
      })
    ).subscribe((response: IResponse) => {
      if (response.success) {
        this.companyService.checkDefaultColumns(this.companyId, {
          month: this.month,
          year: this.year,
          installment: this.installment
        }).pipe(
          takeUntil(this.destroy$)
        ).subscribe((res: any) => {
          this.defaultColumns = res.column;
          this.defaultPndStl = res.column.expense ? res.column.expense.filter(i => !i.editable && i.isChecked) : [];
          const expense = response.data.expenseColumns;
          setIncomeLocalStorage(response.data.incomeColumns.map(item => item.unit ?
            this.buildNameWithUnit(item.name, item.unit) :
            item.name
          ));
          let expenditures = [];
          expense.forEach(item => {
              if (item.unit) {
                expenditures.push(this.buildNameWithUnit(item.name, item.unit));
              } else {
                expenditures.push(item.name);
              }
            }
          )
          expenditures = this.addSpecialExtendColumns(expenditures, false)
          setExpenditureLocalStorage(expenditures);
          this.getSelectedPayroll();
          const data = response.data;
          this.buildData(data, true);
          // refresh qs
          this.router.navigate(['.'], { relativeTo: this.route, queryParams: {...this.route.snapshot.queryParams, force: '1'}});
        });
      }
    });
  }

  buildNameWithUnit(name: string, unit: string): string {
    return `${name}_${unit}`;
  }

  updateEmployeeListFromCaches() {
    this.employeeCaches?.forEach(emp => {
      const index = this.employeeList?.findIndex(d=> d.employee_id === emp.employee_id)
      if (index >= 0) {
        this.employeeList[index] = _.merge(this.employeeList[index], emp);
      }
    })
  }

  buildData(data, isLoadColumns = false): void {
    // this.installment = data?.installment;
    this.startRowIndex = this.page ? ((this.page - 1) * PAGE_LIMIT) + 1: 1;
    if (environment.alwaysAutoCalPayroll) {
      this.canAutocal = true
    } else {
      this.canAutocal = IsEmptyValue(data.autocal) ? this.checkDateAutoCal() : data.autocal
    }
    this.payrollId = data.id;
    this.isLoading = false;
    this.employeeList = this.sortEmployee(data.employees)?.filter(d => !this.employeeRemoved.includes(d.employee_id));
    this.updateEmployeeListFromCaches();
    const tempEmployeeCurrent = data.current_employees ?
      data.current_employees.filter(item => item.end_date === null || this.checkInCurrenMonth(item.end_date)) : [];
    this.employeeCurrent = _.uniqBy(this.employeeCurrent.concat(tempEmployeeCurrent), (d) => d.employee_id);
    const tempEmployeeOld = data.current_employees ?
      data.current_employees.filter(item => item.end_date !== null && this.checkPastDate(item.end_date)) : [];
    this.employeeOld = _.uniqBy(this.employeeOld.concat(tempEmployeeOld), (d) => d.employee_id);

    if (isLoadColumns) {
      this.incomeColumnsNoFormat = data.incomeColumns;
      this.expenseColumnsNoFormat = data.expenseColumns;
      this.incomeColumnsHeader = this.formatColumnHeader(data.incomeColumns, INCOMECOLUMNS);
      this.expenditureColumnsHeader = this.formatColumnHeader(data.expenseColumns, EXPENDITURECOLUMNS);
    }

    this.incomeColumnsData = this.employeeList ?
      this.employeeList.map(item => this.formatColumnData(item, this.incomeColumns, INCOME)) : null;
    this.expenditureColumnsData = this.employeeList ?
      this.employeeList.map(item => this.formatColumnData(item, this.expenditureColumns, EXPENSE)) : null;
    this.incomeFooter = this.formatFooter(INCOMECOLUMNS);
    this.expenseFooter = this.formatFooter(EXPENDITURECOLUMNS);
    this.summaryFooter = this.formatSummaryFooter();
    this.totalData = this.formatTotal();
    this.extendData = this.formatExtendData();
    this.payDate = data.payDate;
    this.employeeListData = this.employeeList;
    this.totalEmployee = data?.total?.total_filtered_employees;
    this.pageTotal = Math.ceil((+this.totalEmployee)/PAGE_LIMIT);
    this.page = this.pageTotal ? this.page: 1;
    this.checkHasPsdStl();
    this.checkEmployeeHasAutoCal();
    this.calculateIncome();
  }

  calculateIncome(): void {
    const cols = this.incomeColumnsHeader?.filter(d =>listHasTime.includes(d.subDataName) && !!d.unit);
    cols.forEach(formattedCol => {
      const subData = listNestedHasTimeHeaderSetting.find(d => d.label === formattedCol.unit)?.lists.find(j => j.labelEn === formattedCol.subDataName);
      let empIndex = [];
      const empList = this.incomeColumnsData?.filter(x => x[formattedCol.name] && !x[formattedCol.subDataName]);
      this.copyLength = empList.length > 0 ? empList.length - 1 : 0;
      this.arr = [];
      empList.forEach((empIncome, i) => {
        this.onTimeUnitPriceChanged({
          value: empIncome[formattedCol.name],
          x : formattedCol.itemOrder,
          y : i
        }, subData, this.doOnIncomeValueChanged.bind(this));
        empIndex.push(i);
      })
    })
  }

  checkHasPsdStl(): void {
    const expense = this.expenseColumnsNoFormat.map(item => item.name);
    const unionArr = [...new Set([...this.defaultPndStl.map(i => i.column), ...expense])];
    if ((!expense.find(i => i.column === pvdStlColumn[0]) || !expense.find(i => i.column === pvdStlColumn[1])) && (unionArr.length !== expense.length)) {
      if (this.defaultPndStl.find(i => i.column === pvdStlColumn[0]) || this.defaultPndStl.find(i => i.column === pvdStlColumn[1])) {
        this.addMoreColumn({column: EXPENDITURECOLUMNS, value: unionArr});
      }
    }
  }

  checkInCurrenMonth(date): boolean {
    if (this.year <= new Date(date).getFullYear()) {
      return this.month <= new Date(date).getMonth() + 1;
    } else {
      return false;
    }
  }

  checkPastDate(date): boolean {
    const firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    return new Date(date) < firstDay;
  }

  checkDateAutoCal(): boolean {
    const now = new Date();
    if (this.month === 12) {
      if (now.getFullYear() > this.year) {
        // ex. now = 12/01/2565
        return now <= new Date(`${this.year + 1}/1/15 23:59:59`);
      } else {
        return true;
      }
    } else {
      const selectedMonth = new Date(`${this.year}/${this.month + 1}/15 23:59:59`);
      return now <= selectedMonth;
    }
  }

  onComeIn(employeeId: string) {
    const tempEmp = this.employeeId;
    if (employeeId) {
      if (!tempEmp && this.state === 'default') {
        this.state === 'default' ? this.state = 'open' : this.state = 'default';
        this.state === 'open' ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'initial');
        this.getEmployeeDetails(employeeId);
      } else {
        if (tempEmp === employeeId) {
          this.state === 'default' ? this.state = 'open' : this.state = 'default';
          this.state === 'open' ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'initial');
          this.employeeId = null;
        } else {
          this.getEmployeeDetails(employeeId);
        }
      }
    } else {
      this.state === 'default' ? this.state = 'open' : this.state = 'default';
      this.state === 'open' ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'initial');
      this.employeeId = null;
    }
  }

  getEmployeeDetails(employeeId): void {
    this.employeeService.getEmployee(this.companyId, employeeId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((employees: any) => {
        this.wrapMiniProfile.nativeElement.right = 0;
        this.employeeId = employeeId;
        this.employeeData = employees.employee;
        this.employeeDeductionData = employees.employee_deduction_data;
        this.bgColor = this.colorList[Math.floor(Math.random() * this.colorList.length)];
      });
  }

  onShowDetailValueChange(value): void {
    this.employeeData = value;
  }


  setDefaultData(params: Params): void {
    this.companyId = params.companyId;
    this.payrollId = params?.payrollId || '';
    this.month = +params.month;
    this.year = +params.year;
    this.installment = +params.installment;
    this.isInstallment = params.isInstallment === 'true' ? true: false;
    this.displayMonthTH = getDisplayMonthTH(+params.month - 1);
    this.minDate = {year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate()};
    this.payrollStatus = params.status;
    const body = {
      companyId: this.companyId,
      month: this.month,
      year: this.year,
    };
    this.companyService.checkDefaultRequestNoti(body).pipe(
      takeUntil(this.destroy$)
    ).subscribe((resp: any) => {
      if (resp.success) {
        this.requestNotiList = resp.data;
      }
    });
    this.companyService.checkDefaultTimeClockColumns(this.companyId, params).pipe(
      takeUntil(this.destroy$)
    ).subscribe((resp: any) => {
      if (resp.success) {
        this.timeClockColumn = resp.column
      }
    });
  }

  getSelectedPayroll(): void {
    this.incomeColumns = getIncomeLocalStorage();
    this.expenditureColumns = getExpenditureLocalStorage();
    this.expenditureColumns = this.addSpecialExtendColumns(this.expenditureColumns, false)
  }

  isIncome(data: string): boolean {
    return data === INCOMECOLUMNS;
  }

  formatColumnData(item: any, column: string[], module: string): any {
    const formatColumnLists = ['socialSecurity']; // ['socialSecurity', 'providentFund', 'studentLoan'];
    const result = {};
    column.map(i => {
      const columnTime = i.split('_');
      if (columnTime.length > 1) {
        result[`${columnTime[0]}Unit`] = item[module][i] > 0 ? formatDecimalPrice(item[module][i]) : '';
        result[`${columnTime[0]}`] = item[module][columnTime[0]] > 0 ? formatDecimalPrice(item[module][columnTime[0]]) : '';
      } else {
        result[i] = module === INCOME ? (
          +item.income[i] === 0 || IsEmptyValue(item.income[i]) ? i === 'salary' ? 0 : '' : formatDecimalPrice(+item.income[i])
        ) : (
          (+item.expense[i] === 0 || IsEmptyValue(item.expense[i])) && i !== CalType.wht ?
            (formatColumnLists.includes(i) ? (item.sso_started ? (+item.expense[i] === 0 ? '' : +item.expense[i]) : '-') : '') :
            formatDecimalPrice(+item.expense[i])
        );

        if (i === 'salary' && result[i] == 0 && item.salary_period == 'วัน') {
          result[i] = ''
        }
      }

      let specialColumn = SpecialColumnPayroll.find(o => o.name == i)
      if (specialColumn && specialColumn.list) {
        specialColumn.list.map((c: any) => {
          result[c.label] = item[module][c.label] > 0 ? formatDecimalPrice(item[module][c.label]) : ''
        })
      }      
    });

    return result;
  }

  formatTotal(): PayrollColumnDataValue[] {
    return this.employeeList ? this.employeeList.map(item => ({
      total_income: formatDecimalPrice(item.total_salary),
      total_expenditure: formatDecimalPrice(item.total_expenditure),
      net_income: formatDecimalPrice(item.net_income),
      total_transfer_to_account: formatDecimalPrice(item.total_transfer_to_account),
    })) : null;
  }

  formatFooter(column: string): PayrollColumnFooter[] {
    let columns = this.incomeColumnsNoFormat;
    let field = INCOME;
    if (!this.isIncome(column)) {
      columns = this.expenseColumnsNoFormat;
      field = EXPENSE;
    }
    const totalAll = {};
    columns = this.addSpecialExtendColumns(columns, true)
    columns.map(item => {
      totalAll[item.name] = this.employeeList ? this.employeeList.reduce((total, obj) => numberWithoutCommas(obj[field][item.name]) + total, 0) : 0;
    });
    return columns.map((value) => ({
        name: value.name,
        summary: formatDecimalPrice(totalAll[value.name]),
        width: listHasTime.includes(value.name) ? 195 : 130,
        pay_tax: this.isIncome(column) ?
          this.allIncomeList.find(item => item.labelEn === value.name)?.pay_tax && {
            ...this.allIncomeList.find(item => item.labelEn === value.name)?.pay_tax,
            isChecked: value.pay_tax
          } || {
            ...AddHocCheckbox?.pay_tax, isChecked: value.pay_tax
          } : null,
        transfer_to_account: this.isIncome(column) ?
          this.allIncomeList.find(item => item.labelEn === value.name)?.transfer_to_account && {
            ...this.allIncomeList.find(item => item.labelEn === value.name)?.transfer_to_account,
            isChecked: value.transfer_to_account
          } || {
            ...AddHocCheckbox?.transfer_to_account, isChecked: value.transfer_to_account
          } : null,
        base_salary_adjustment: this.isIncome(column) ?
          this.allIncomeList.find(item => item.labelEn === value.name)?.base_salary_adjustment && {
            ...this.allIncomeList.find(item => item.labelEn === value.name)?.base_salary_adjustment,
            isChecked: value.base_salary_adjustment
          } || {
            ...AddHocCheckbox?.base_salary_adjustment, isChecked: value.base_salary_adjustment
          } : null,
        extra_column: value.extra_column,
        reduceSalary: this.reduceSalaryChecked(value.name),
        reference: value.reference,
      })
    );
  }

  formatSummaryFooter(): PayrollColumnFooter[] {
    const columns = ['total_income', 'total_expenditure', 'net_income', 'total_transfer_to_account'];
    const total = {};
    columns.map(item => {
      total[item] = 0;
      if (item === 'total_income') {
        if (this.employeeList) {
          this.employeeList.map(employee => {
            total[item] = total[item] + parseFloat(employee.total_salary);
          });
        }
      } else {
        if (this.employeeList) {
          this.employeeList.map(employee => {
            total[item] = total[item] + parseFloat(employee[item]);
          });
        }
      }
    });
    return columns.map(item => ({
      name: item,
      summary: formatDecimalPrice(total[item]),
      width: 130,
    }));
  }

  formatExtendData(): PayrollColumnDataValue[] {
    return this.employeeList ? this.employeeList.map(item => ({
      remark: item.remark,
    })) : null;
  }

  addMoreColumn(data: any): void {
    const diff = this.isIncome(data.column) ?
      getArrayDiff(data.value, getIncomeLocalStorage()) :
      getArrayDiff(data.value, getExpenditureLocalStorage());
    const moreValue = {};
    diff.map(item => {
      const col = item.split('_');
      if (col.length > 1) {
        moreValue[col[0]] = '0';
      }
      moreValue[item] = '0';
    });
    if (this.isIncome(data.column)) {
      this.employeeList = this.employeeList.map(item => ({
        ...item,
        income: _.merge(item.income, moreValue)
      }));
      this.reorderCols(this.allIncomeList, uniq(data.value), INCOMECOLUMNS);
      setIncomeLocalStorage(this.incomeColumns);
      //this.updateRecalType = [RecalType.socialSecurity, RecalType.withholdingTax];
    } else {
      this.employeeList = this.employeeList.map(item => ({
        ...item,
        expense: _.merge(item.expense, moreValue)
      }));
      this.reorderCols(this.allExpenseList, uniq(data.value), EXPENDITURECOLUMNS);
      setExpenditureLocalStorage(this.expenditureColumns);
      // const allExpCols = [...this.expenditureColumns, ...diff];
      // this.updateRecalType = allExpCols.includes(CalType.payCut) ? [RecalType.socialSecurity, RecalType.withholdingTax] : [RecalType.withholdingTax];
      // if (intersection(diff.map(d=> d.split('_')[0]), autoCalPvdExpenseColumn)?.length > 0) {
      //   this.updateRecalType.push(RecalType.providentFund);
      // }
    }
    this.loadMoreColumn(data.column);
  }

  reorderCols(defaultLists: DataSets[], selectedList: string[], columnName: string): void {
    this[columnName] = reorderColumns(defaultLists, selectedList);
  }

  loadMoreColumn(module: string): void {
    const body = {
      companyId: this.companyId,
      payrollId: this.payrollId,
      type: this.isIncome(module) ? INCOME : EXPENSE,
      columns: this.isIncome(module) ? getIncomeLocalStorage()
        : getExpenditureLocalStorage(),
      employees: this.employeeList?.map(d=> d.employee_id)
    };
    this.companyService.generateAddMoreColumn(body).pipe(
      takeUntil(this.destroy$)
    ).subscribe((response: IResponse) => {
      if (response.success) {
        if (this.isIncome(module)) {
          let dataIncomeColumns = this.removeSpecialExtendColumns(response.data.incomeColumns, false)
          this.incomeColumns = getIncomeLocalStorage();
          this.incomeColumnsHeader = this.formatColumnHeader(dataIncomeColumns, INCOMECOLUMNS);
          const mergedCols = dataIncomeColumns.map(item => {
            const existing = this.incomeColumnsNoFormat.find(d => d.name === item.name) || {}
            return {...item, ...existing}
          })
          this.incomeColumnsNoFormat = mergedCols;
          this.incomeFooter = this.formatFooter(INCOMECOLUMNS);
        } else {
          let dataExpenseColumns = this.removeSpecialExtendColumns(response.data.expenseColumns, false)
          this.expenditureColumns = getExpenditureLocalStorage();
          this.expenditureColumns = this.addSpecialExtendColumns(this.expenditureColumns, false)
          this.expenditureColumnsHeader = this.formatColumnHeader(dataExpenseColumns, EXPENDITURECOLUMNS);
          const mergedCols = dataExpenseColumns.map(item => {
            const existing = this.expenseColumnsNoFormat.find(d => d.name === item.name) || {}
            return {...item, ...existing}
          })
          this.expenseColumnsNoFormat = mergedCols;
          this.expenseFooter = this.formatFooter(EXPENDITURECOLUMNS);
        }
        this.checkWhtColumnNoChanged();
        this.totalData = this.formatTotal();
        this.recalculate([0], true);
        this.isAutoRecalColumn = true;
      }
    });
  }

  createSaveObs(specialEmployees = null) {
    const body = {
      pay_date: '',
      employees: null,
      incomeColumns: this.incomeColumnsNoFormat,
      expenseColumns: this.expenseColumnsNoFormat,
      companyId: this.companyId,
      payrollId: this.payrollId,
    };
    const list = [];
    const chunkSize = 1000;
    let employees = cloneDeep(this.employeeList);
    this.employeeCaches?.forEach(emp => {
      const dup = this.employeeList?.find(d=> d.employee_id === emp.employee_id);
      if (!dup) {
        employees.push(emp);
      }
    });
    if (specialEmployees) {
      specialEmployees?.forEach(emp => {
        const dup = employees?.find(d=> d.employee_id === emp.employee_id);
        if (!dup) {
          employees.push(emp);
        }
      });
    }
    for (let i = 0; i < employees.length; i += chunkSize) {
      const input = {...body, employees: employees.slice(i, i + chunkSize)};
      list.push(this.companyService.saveDraftPayroll(input));
    }
    // Delete employee
    const b2 = {
      companyId: this.companyId,
      payrollId: this.payrollId,
    };
    let deleteList = []
    const employeeIdList = employees?.map(item => item.employee_id);
    this.employeeRemoved = this.employeeRemoved.filter(item => !employeeIdList.includes(item));
    for (let i = 0; i < this.employeeRemoved.length; i += chunkSize) {
      const input = {...b2, employees: this.employeeRemoved.slice(i, i + chunkSize)};
      deleteList.push(this.companyService.deleteEmployeeFromPayroll(input));
    }

    // Auto recal column
    let autoRecalObs = null
    if (this.isAutoRecalColumn) {
      const autoRecalInputBody = {
        employees: employees?.map(emp => emp.employee_id),
        incomeColumns: this.incomeColumnsNoFormat,
        expenseColumns: this.expenseColumnsNoFormat,
        companyId: this.companyId,
        payrollId: this.payrollId
      }
      autoRecalObs = this.companyService.savePayrollAutoRecal(autoRecalInputBody).pipe(
        tap(()=> {
          this.isAutoRecalColumn = false;
        })
      );
    }
    return forkJoin(list).pipe(
      mergeMap(res => {
        if (deleteList?.length > 0) {
          return forkJoin(deleteList).pipe(
            map(code => ([...res, ...code]))
          );
        }
        return of(res)
      }),
      mergeMap(res2 => {
        if (autoRecalObs) {
          return autoRecalObs.pipe(
            map(recal => ([...res2, recal]))
          );
        }
        return of(res2)
      })
    );
  }

  saveDraft(): void {
    this.isLoadingSpin = true;
    const listObs = this.createSaveObs();
    listObs.pipe(
      takeUntil(this.destroy$)
    ).subscribe((response: IResponse[]) => {
      let success = true;
      response.forEach(res => {
        if (!res.success) {
          success = false;
        }
      });
      if (success) {
        this.canRedirect = true;
        this.redirectToPayrollList();
        this.isLoadingSpin = false;
        this.employeeRemoved = [];
      }
    });
  }

  save(url): void {
    const listObs = this.createSaveObs();
    listObs.pipe(
      takeUntil(this.destroy$)
    ).subscribe((response: IResponse[]) => {
      let success = true;
      response.forEach(res => {
        if (!res.success) {
          success = false;
        }
      });
      if (success) {
        this.employeeRemoved = [];
        this.canRedirect = true;
        this.router.navigateByUrl(url);
      }
    });
  }

  dontSave(url): void {
    if (this.payrollStatus == PayrollStatus.init) {
      this.confirmResetPayroll(url)
    } else {
      this.canRedirect = true;
      this.router.navigateByUrl(url);
    }
  }

  handleConfirmPayroll(): void {
    let element = this.contentPayDate;
    if (this.canAutocal) {
      // this.checkAllIsEmpty();
    }
    if (this.isAllExpenseEmpty) {
      element = this.contentWarning;
    }
    this.openModal(element);
  }

  checkAllIsEmpty(): void {
    let isEmpty = true;
    this.isAllExpenseEmpty = true;
    this.employeeList.map(emp => {
      if (Object.values(emp.expense).find(x => +x !== 0)) {
        isEmpty = false;
        this.isAllExpenseEmpty = false;
      }
    });
  }

  onSetPayDate(date): void {
    this.payDate = date;
    this.confirmPayroll();
  }

  confirmPayroll(): void {
    // this.employeeList = this.checkHideColumnAllEmptyValue();
    this.isLoadingSpin = true;
    const body = {
      pay_date: formatDatePickerTo(this.payDate),
      companyId: this.companyId,
      payrollId: this.payrollId,
    };
    const listObs = this.createSaveObs();
    listObs.pipe(
      mergeMap((response: IResponse[]) => {
        let success = true;
        response.forEach(res => {
          if (!res.success) {
            success = false;
          }
        });
        if (success) {
          this.employeeRemoved = [];
          return this.companyService.confirmPayroll(body);
        }
      }),
      takeUntil(this.destroy$)
    ).subscribe((response: IResponse) => {
      if (response.success) {
        this.isLoadingSpin = false;
        this.canRedirect = true;
        this.modalRef.hide();
        this.payrollStatus = PayrollStatus.confirmed;
        this.payrollId = response.data.id;
        this.redirectToPayrollListAndSelectMonth();
      }
    });
  }

  checkHideColumnAllEmptyValue(): any {
    const incomes = this.incomeColumnsNoFormat.map(subData => this.allIncomeList.find(item => item.labelEn === subData.name) ?
      this.allIncomeList.find(item => item.labelEn === subData.name).labelEn : subData.name);
    const expenses = this.expenseColumnsNoFormat.map(subData => this.allExpenseList.find(item => item.labelEn === subData.name) ?
      this.allExpenseList.find(item => item.labelEn === subData.name).labelEn : subData.name);
    incomes.map(income => {
      if (this.employeeList.every(employee => employee.income[income] === '0')) {
        this.employeeList.map(item => delete item.income[income]);
        this.incomeColumnsNoFormat = this.incomeColumnsNoFormat.filter(item => item.name !== income);
      }
    });
    expenses.map(expense => {
      if (this.employeeList.every(employee => employee.expense[expense] === '0') && (!this.defaultPndStl.map(i => i.column).includes(expense))) {
        this.employeeList.map(item => delete item.expense[expense]);
        this.expenseColumnsNoFormat = this.expenseColumnsNoFormat.filter(item => item.name !== expense);
      }
    });
    return this.employeeList;
  }

  handleResetPayroll(event: MouseEvent, modalContent: any): void {
    this.openModal(modalContent);
  }

  openModal(content: any): void {
    this.modalRef = this.modalService.show(content, {backdrop: 'static', class: 'custom-modal'});
  }

  confirmResetPayroll(redirectUrl?: any): void {
    this.companyService.resetPayroll(this.companyId, this.payrollId).pipe(
      takeUntil(this.destroy$)
    ).subscribe((response: IResponse) => {
      if (response.success) {
        if (redirectUrl) {
          this.canRedirect = true;
          this.router.navigateByUrl(redirectUrl);
        } else {
          const snapshotFilters: Params = this.route.snapshot.queryParams;
          const qs: Keypair = {...snapshotFilters};
          if (qs.status === PayrollStatus.draft) {
            qs.status = PayrollStatus.init;
          }
          qs.started = false;
          qs.installment = 1;
          delete qs.force;
          delete qs.month;
          this.router.navigate(['../'], {relativeTo: this.route, queryParams: qs});
          this.canRedirect = true;
          if (this.modalRef) {
            this.modalRef.hide();
          }
        }
      }
    });
  }

  redirectToPayrollList(): void {
    const snapshotFilters: Params = this.route.snapshot.queryParams;
    const qs: Keypair = {...snapshotFilters};
    qs.payrollId = this.payrollId || qs.payrollId;
    delete qs.month;
    delete qs.started;
    delete qs.force;
    this.router.navigate(['../'], {relativeTo: this.route, queryParams: qs});
  }

  redirectToPayrollListAndSelectMonth(): void {
    const snapshotFilters: Params = this.route.snapshot.queryParams;
    const qs: Keypair = {...snapshotFilters};
    delete qs.started;
    delete qs.force;
    qs.status = PayrollStatus.confirmed;
    qs.payrollId = this.payrollId;
    this.router.navigate(['../'], {relativeTo: this.route, queryParams: qs});
  }

  formatColumnHeader(data, column): PayrollColumnHeader[] {
    let col: DataSets[] = this.allIncomeList;
    let endDateCol: DataSets[] = ENDDATEINCOMELIST;
    const arr: PayrollColumnHeader[] = [];
    // let onValueChanged; // this.onIncomeValueChanged;
    if (!this.isIncome(column)) {
      col = this.allExpenseList;
      endDateCol = ENDDATEEXPENSELIST;
      // onValueChanged = this.onExpenditureValueChanged;
    }
    let order = 0;
    data = this.removeSpecialExtendColumns(data, true)
    data.map((subData: any) => {
      if (listHasTime.includes(subData.name)) {
        listNestedHasTimeHeaderSetting.map((val: any) => {
          order += 1;
          arr.push({
            name: `${subData.name}${val.label === '' ? '' : val.label.charAt(0).toUpperCase() + val.label.slice(1)}`,
            itemOrder: order,
            labelEn: `${subData.name}_${subData.unit}`,
            title: val.lists.find(j => j.labelEn === subData.name).labelTh,
            type: val.type,
            width: val.width,
            mask: val?.mask,
            decimal: '.',
            extra_column: false,
            subDataName: subData.name,
            unit: val.label,
            customReadOnly: this.setReadOnly(subData.name)
          });
        });
      } else {
        let specialColumn = SpecialColumnPayroll.find(o => o.name == subData.name)
        let title = col.find(item => item.labelEn === subData.name) ?
            col.find(item => item.labelEn === subData.name).label : subData.name
        if (specialColumn && specialColumn.title) {
          title = specialColumn.title
        } 

        order += 1;
        arr.push({
          name: col.find(item => item.labelEn === subData.name) ?
            col.find(item => item.labelEn === subData.name).labelEn : subData.name,
          itemOrder: order,
          labelEn: col.find(item => item.labelEn === subData.name) ?
            col.find(item => item.labelEn === subData.name).labelEn : subData.name,
          title: title,
          type: 'numeric',
          width: 130,
          mask: '#,##.00',
          decimal: '.',
          extra_column: subData?.extra_column,
          readOnly: !!endDateCol.find(item => item.labelEn === subData.name),
          customReadOnly: this.setReadOnly(subData.name)
          // onChange: onValueChanged
        });

        if (specialColumn && specialColumn.list) {
          specialColumn.list.map((c: any) => {
            order += 1;
            arr.push({
              name: c.label,
              itemOrder: order,
              labelEn: c.label,
              title: c.labelTh,
              type: 'numeric',
              width: 130,
              mask: '#,##.00',
              decimal: '.',
              extra_column: c.extra_column,
              readOnly: c.readOnly,
              reference: c.reference,
            });
          })
        }
      }
    });
    return arr;
  }

  setReadOnly(col: string) {
    if (CustomReadOnlyCols.indexOf(col) >= 0) {
      return this.handleReadOnly.bind(this);
    }
    return null;
  }


  handleReadOnly(data, x, y, instance): boolean {
    if (instance) {
      const colName = instance.jexcel.options.columns[x]?.name;
      if (colName === 'wage' || colName === 'wageUnit') {
        return this.employeeList?.[y]?.salary_period ? this.employeeList?.[y]?.salary_period === 'เดือน': false;
      } else if (colName === 'salary') {
        return this.employeeList?.[y]?.salary_period ? this.employeeList?.[y]?.salary_period !== 'เดือน': false;
      }
    }
  }

  onSetCopyLength(value): void {
    if (value.copyLength && value.copyLength !== this.copyLength) {
      this.copyLength = value.copyLength;
      if (value.tableId === 'incomeTable') {
        if (this.arr.length === this.copyLength && !this.isProceedData) {
          this.isProceedData = true;
          this.arr.map(item => {
            this.onProcessIncomeValueChanged(item.x, [item.y], [item.value]);
          });
          this.recalculate(this.arr.map(i => +i.y));
        }
      } else {
        if (this.arr.length === this.copyLength) {
          this.isProceedData = true;
          this.arr.map(item => {
            this.onProcessExpenseValueChanged(item.x, [item.y], [item.value]);
          });
          this.recalculate(this.arr.map(i => +i.y));
        }
      }
    }
  }

  onValueChanged(value, cbOnValueChanged): void {
    const col = value.instance.jexcel.options.columns[value.x];
    if (listHasTime.includes(col.subDataName)) {
      const subData = listNestedHasTimeHeaderSetting.find(d => d.label === col.unit)?.lists.find(j => j.labelEn === col.subDataName);
      this.onTimeUnitPriceChanged(value, subData, cbOnValueChanged.bind(this));
    } else {
      cbOnValueChanged(value);
    }
  };

  onIncomeValueChanged(value): void { // todo duplicate
    this.onValueChanged(value, this.doOnIncomeValueChanged.bind(this));
  }

  doOnIncomeValueChanged(value): void {
    if (this.copyLength === 0) {
      this.onProcessIncomeValueChanged(value.x, [value.y], [value.value]);
      this.recalculate([+value.y]);
    } else {
      this.isExcelLoading = true;
      this.arr = [...this.arr, value];
      if (this.arr.length === this.copyLength) {
        this.arr.map(item => {
          this.onProcessIncomeValueChanged(item.x, [item.y], [item.value]);
        });
        this.recalculate(this.arr.map(i => +i.y));
      }
    }
  }

  onProcessIncomeValueChanged(x, yList, value): void {
    const columns = this.incomeColumnsHeader.map(i => i.labelEn);
    const columnChanged = columns[x];
    if (!listHasTime.includes(columnChanged.split('_')[0])) {
      this.updateRecalType = [RecalType.socialSecurity, RecalType.withholdingTax]; // [RecalType.withholdingTax];
      if (columnChanged === 'salary') {
        this.updateRecalType.push(RecalType.providentFundPercentage);
        this.updateRecalType.push(RecalType.providentFundEmployer);
      }
      yList.map((y, index) => {
        this.incomeColumnsData[y][columnChanged] = value[index];
        this.updateTempEmployeeDataChanged(INCOME, columnChanged, value[index], y);
      });
    }
  };

  onExpenseValueChanged(value): void { // todo duplicate
    this.onValueChanged(value, this.doOnExpenseValueChanged.bind(this));
  };

  doOnExpenseValueChanged(value): void {
    if (this.copyLength === 0) {
      this.onProcessExpenseValueChanged(value.x, [value.y], [value.value]);
      this.recalculate([+value.y]);
    } else {
      this.arr = [...this.arr, value];
      if (this.arr.length === this.copyLength) {
        this.arr.map(item => {
          this.onProcessExpenseValueChanged(item.x, [item.y], [item.value]);
        });
        this.recalculate(this.arr.map(i => +i.y));
      }
    }
  };

  onProcessExpenseValueChanged(x, yList, value): void {
    const columns = this.expenditureColumnsHeader.map(i => i.labelEn);
    const columnChanged = columns[x];
    if (!listHasTime.includes(columnChanged.split('_')[0])) {
      this.updateRecalType = columnChanged === CalType.wht ? this.updateRecalType.filter(i => i !== RecalType.withholdingTax) :
        columnChanged === CalType.payCut ? [RecalType.socialSecurity, RecalType.withholdingTax] : [RecalType.withholdingTax];
      yList.map((y, index) => {
        this.expenditureColumnsData[y][columnChanged] = value[index];
        if (this.canAutocal) {
          if (autoCalColumnList.includes(columnChanged) && !this.autoCalColumn.includes(columnChanged)) {
            this.autoCalColumn = [...this.autoCalColumn, columnChanged];
          }
          if (autoCalColumnList.includes(columnChanged)) {
            this.onTableValueChangedAndSetDataAndStyle({
              row: +y,
              col: +x,
              value: +numberWithoutCommas(value[index]),
              name: columnChanged,
              styleChanged: true
            }, expenseHasChanged);
          }
        }
        this.updateTempEmployeeDataChanged(EXPENSE, columnChanged, +numberWithoutCommas(value[index]), +y);
      });
    }
    if (autoCalPvdExpenseColumn.includes(columnChanged.split('_')[0])) {
      this.updateRecalType.push(RecalType.providentFundPercentage);
    }
  };

  onExtendValueChanged(value): void {
    const columnChanged = this.extendColumns[value.x].labelEn
    const employeeIndex = +value.y

    var newValue = value.value
    if (columnChanged == 'remark' && newValue.length > 250) {
      newValue = newValue.substring(0, 250)
    }

    this.extendData[value.y][columnChanged] = newValue
    this.employeeList[employeeIndex][columnChanged] = newValue
  }

  updateTempEmployeeDataChanged(column, columnChange, newValue, employeeIndex): void {
    const getEmployeeChanged = this.employeeList[employeeIndex];
    const getEmployeeTemp = this.employeeTempList.find(item => item.employee_id === getEmployeeChanged.employee_id);
    const arr = this.employeeTempList.filter(item => item.employee_id !== getEmployeeChanged.employee_id);
    if (getEmployeeTemp) {
      this.employeeTempList = this.employeeTempList.map(i => {
        if (i.employee_id !== getEmployeeChanged.employee_id) {
          return {...i};
        } else {
          return {
            ...i,
            auto_calculated_column: autoCalColumnList.includes(columnChange) ?
              (i.auto_calculated_column ? [...i.auto_calculated_column, columnChange] : [columnChange]) :
              i.auto_calculated_column ? [...i.auto_calculated_column] : i.auto_calculated_column,
            [column]: {
              ...i[column],
              [columnChange]: numberWithoutCommas(newValue).toString()
            }
          };
        }
      });
    } else {
      arr.push({
        ...getEmployeeChanged,
        auto_calculated_column: autoCalColumnList.includes(columnChange) ?
          (getEmployeeChanged.auto_calculated_column ? [...getEmployeeChanged.auto_calculated_column, columnChange] : [columnChange]) :
          getEmployeeChanged.auto_calculated_column ? [...getEmployeeChanged.auto_calculated_column] : getEmployeeChanged.auto_calculated_column,
        [column]: {
          ...getEmployeeChanged[column],
          [columnChange]: numberWithoutCommas(newValue).toString()
        }
      });
      this.employeeTempList = arr;
    }
    this.employeeCaches = cloneDeep(this.employeeTempList);
  }

  recalculate(whtRow: number[], isAll: boolean = false): void {
    this.isExcelLoading = true;
    if (this.setNocalWht) {
      this.updateRecalType = this.updateRecalType.filter(item => item !== RecalType.withholdingTax);
    }
    const empIds = this.employeeList.filter((i, k) => whtRow.includes(k)).map(emp => emp.employee_id);
    let employees = isAll ? this.employeeList : this.employeeTempList.filter(i => empIds.includes(i.employee_id));
    this.employeeCaches?.forEach(emp => {
      const dup = employees.find(d => d.employee_id === emp.employee_id);
      if (!dup) {
        const samePage = this.employeeList.find((j) => j.employee_id === emp.employee_id);
        if (!samePage) {
          employees.push(emp);
        }
      }
    });
    this.updateRecalType = uniq(this.updateRecalType);
    const body = {
      companyId: this.companyId,
      payrollId: this.payrollId,
      type: this.canAutocal ? this.updateRecalType : [],
      employees: null,
      incomeColumns: this.incomeColumnsNoFormat,
      expenseColumns: this.expenseColumnsNoFormat
    };
    const randomKey = Math.random();
    this.excelLoadingCollection[randomKey] = true;
    const list = [];
    const chunkSize = 1000;
    for (let i = 0; i < employees.length; i += chunkSize) {
      const employ = employees.slice(i, i + chunkSize);
      const input = {...body, employees: employ};
      list.push(this.companyService.recalculateWithholdingTax(input));
    }
    forkJoin(list).pipe(
      takeUntil(this.destroy$),
      tap(v => {
        this.excelLoadingCollection[randomKey] = false;
      }),
      first()
    ).subscribe((res: any) => {
      const response = {
        employees: res.map(item => item.employees)?.reduce((a, b) => [...a, ...b]),
      };
      this.employeeList = this.employeeList.map(item => {
        if (isAll) {
          const obj = response.employees.find(i => i.employee_id === item.employee_id);
          return _.merge(item, obj);
        } else if (response.employees.map(i => i.employee_id).includes(item.employee_id)) {
          const obj1 = this.employeeTempList.find(i => i.employee_id === item.employee_id);
          const obj2 = response.employees.find(i => i.employee_id === item.employee_id);
          return _.merge(obj1, obj2);
        } else {
          return {
            ...item
          };
        }
      });
      this.incomeColumnsData = this.employeeList.map(item => this.formatColumnData(item, this.incomeColumns, INCOME));
      this.expenditureColumnsData = this.employeeList.map(item => this.formatColumnData(item, this.expenditureColumns, EXPENSE));
      if (this.canAutocal) {
        this.updateRecalType.map(type => {
          if (type === RecalType.providentFundPercentage) {
            type = RecalType.providentFund;
          }
          if (isAll) {
            this.employeeList.map((item, index) => {
              this.onTableValueChangedAndSetDataAndStyle({
                row: index,
                col: CalType[type] === CalType.wht ? this.expenditureColumnsHeader.findIndex(item => item.labelEn === CalType.wht)
                  : this.expenditureColumns.indexOf(CalType[type]),
                value: +response.employees.find(i => i.employee_id === item.employee_id).expense[CalType[type]] === 0 && CalType[type] !== CalType.wht ? ''
                  : +response.employees.find(i => i.employee_id === item.employee_id).expense[CalType[type]],
                name: CalType[type],
                styleChanged: false
              }, expenseHasChanged);
              this.employeeList = this.employeeList.map((emp, key) => ({
                ...emp,
                auto_calculated_column: emp.auto_calculated_column ?
                  emp.auto_calculated_column.filter(i => i !== CalType[type]) : emp.auto_calculated_column
              }));
            });
          } else {
            response.employees.map((item) => {
              const index = this.employeeList.findIndex(i => i.employee_id === item.employee_id);
              if (response.employees.find(i => i.employee_id === item.employee_id).expense.hasOwnProperty(CalType[type])) {
                this.onTableValueChangedAndSetDataAndStyle({
                  row: this.employeeList.findIndex(i => i.employee_id === item.employee_id),
                  col: CalType[type] === CalType.wht ? this.expenditureColumnsHeader.findIndex(item => item.labelEn === CalType.wht)
                    : this.expenditureColumns.indexOf(CalType[type]),
                  value: +response.employees.find(i => i.employee_id === item.employee_id).expense[CalType[type]] === 0 && CalType[type] !== CalType.wht ? ''
                    : +response.employees.find(i => i.employee_id === item.employee_id).expense[CalType[type]],
                  name: CalType[type],
                  styleChanged: false
                }, expenseHasChanged);
              }
              this.employeeList = this.employeeList.map((emp, key) => ({
                ...emp,
                auto_calculated_column: key === index && emp.auto_calculated_column ?
                  emp.auto_calculated_column.filter(i => i !== CalType[type]) : emp.auto_calculated_column
              }));
            });
          }
        });
      }
      this.arr = [];
      this.updateRecalType = [];
      this.copyLength = 0;
      this.setNocalWht = false;
      this.isProceedData = false;
      this.recalTotal();
      this.updateEmployeeCaches(response);
      this.isExcelLoading = !Object.values(this.excelLoadingCollection).every(d => d === false);
      if (!this.isExcelLoading) {
        this.excelLoadingCollection = {};
      }
    });
  }

  updateEmployeeCaches(response): void {
    this.employeeCaches = this.employeeCaches?.map(emp => {
      const newEmpValue = this.employeeList.find(d => d.employee_id === emp.employee_id);
      if (newEmpValue) {
        return newEmpValue;
      } else {
        const obj = response.employees.find(i => i.employee_id === emp.employee_id);
        if (obj) {
          return _.merge(emp, obj);
        }
      }
      return emp;
    })
  }

  recalTotal(): void {
    this.recalculateTotal();
    this.checkHasFooterAutoCal();
  }

  recalculateTotal(): void {
    this.totalData = this.formatTotal();
    this.summaryFooter = this.formatSummaryFooter();
    this.incomeFooter = this.formatFooter(INCOMECOLUMNS);
    this.expenseFooter = this.formatFooter(EXPENDITURECOLUMNS);
  }

  resetAllInColumn(): void {
    this.openModal(this.contentAutoCal);
  }

  resetColumnValue(item: any): void {
    this.employeeList[+item.row] = {
      ...this.employeeList[+item.row],
      auto_calculated_column: this.employeeList[+item.row].auto_calculated_column ?
        this.employeeList[+item.row].auto_calculated_column.filter(col => col !== item.name) :
        this.employeeList[+item.row].auto_calculated_column
    };
    this.employeeTempList = [this.employeeList[+item.row]];
    this.updateRecalType = item.name === CalType.wht ? [RecalType[item.name]] : [RecalType[item.name], RecalType.withholdingTax];
    this.recalculate([+item.row], false);
  }

  checkHasFooterAutoCal(): void {
    this.autoCalColumn = uniq(this.expenseHasChanged.filter(sub => sub.styleChanged).map(item => item.name));
  }

  onTimeUnitPriceChanged = (data, subData, cbOnValueChnage) => {
    const value = data.value;
    const y = data.y;
    if (subData.value === 'unit') {
      this.updateTempEmployeeDataChanged(subData.column, `${subData.labelEn}_${subData.timeUnit}`, numberWithoutCommas(value), y);
      if (subData.labelEn == 'wage') {
        let params = { day: value }
        this.employeeService.calculatePayrollWage(this.companyId, this.employeeList[y].employee_id, params).subscribe(
          (resp:any) => {
            if (resp.success) {
              let calPrice = (resp.required) ? parseFloat(resp.required) : 0
              this.recalTimeUnitPriceChanged(subData.column, subData.labelEn, calPrice, y);
              cbOnValueChnage(data);
            }
          }
        )
      } else {
        let calPrice = this.calOtPrice(this.employeeList[y].salary, subData, numberWithoutCommas(value), this.employeeList[y].salary_period);
        this.recalTimeUnitPriceChanged(subData.column, subData.labelEn, calPrice, y);
        cbOnValueChnage(data);
      }
    } else { // note: subData.value === 'price'
      let calPrice = numberWithoutCommas(value)
      this.recalTimeUnitPriceChanged(subData.column, subData.labelEn, calPrice, y)
      if (numberWithoutCommas(value) === 0 || numberWithoutCommas(value) !== this.employeeList[y][subData.column][subData.labelEn]) {
        let listUnit = listNestedHasTimeHeaderSetting.find(o => o.label == 'unit').lists
        let timeUnit = listUnit.find(o => o.labelEn == subData.labelEn).timeUnit
        this.updateTempEmployeeDataChanged(subData.column, `${subData.labelEn}_${timeUnit}`, 0, y);
      }
      cbOnValueChnage(data);
    }
  };

  recalTimeUnitPriceChanged(column, labelEn, calPrice, y): void {
    this.updateRecalType = [RecalType.socialSecurity, RecalType.withholdingTax];
    this.updateTempEmployeeDataChanged(column, labelEn, formatDecimalPrice(calPrice), y);
  }

  calOtPrice(salary, subData, hour, salaryPeriod): number {
    if (salaryPeriod === 'เดือน') {
      return (((salary / TotalWorkDay) / TotalWorkHour) * subData.rate) * this.formatValueHour(hour);
    }
    const dayRate = subData.rateSalaryPeriodDay || subData.rate;
    return ((salary / TotalWorkHour) * dayRate) * this.formatValueHour(hour);
  }

  formatValueHour(value: number): number {
    const data = value.toFixed(2).split('.');
    if (data.length > 1) {
      const minToHour = +data[1] * 0.016667;
      value = (+data[0]) + (+minToHour.toFixed(2));
    }
    return value;
  }

  onTableValueChangedAndSetDataAndStyle(obj: any, field: string): void {
    if (this[field].find(i => +i.col === +obj.col && +i.row === +obj.row)) {
      const index = this[field].findIndex(i => +i.col === +obj.col && +i.row === +obj.row);
      this[field] = [
        ...this[field].slice(0, index),
        ...this[field].slice(index + 1)
      ];
    } else if (this[field].find(i => i.name === obj.name && +i.row === +obj.row && +i.col !== +obj.col)) {
      const index = this[field].findIndex(i => i.name === obj.name && +i.row === +obj.row && +i.col !== +obj.col);
      this[field] = [
        ...this[field].slice(0, index),
        ...this[field].slice(index + 1)
      ];
    }
    this[field] = [...this[field], {
      ...obj,
      row: +obj.row,
      col: +obj.col
    }];
  }

  reduceSalaryChecked(name: string): boolean {
    const checkList = ['late', 'absent', 'payCut'];
    return checkList.includes(name);
  }

  onConfigFooterChanged(value: any): void {
    const payTax = 'pay_tax';
    const baseSalary = 'base_salary_adjustment';
    const field = value.id.split(',');
    const val = value.checked;
    this.incomeColumnsNoFormat = this.incomeColumnsNoFormat.map(i => {
        if (i.name === field[0]) {
          if (field[1] === baseSalary) {
            return {
              ...i,
              [field[1]]: val,
              [payTax]: !i[payTax] ? true : i[payTax]
            };
          } else if (field[1] === payTax) {
            return {
              ...i,
              [field[1]]: val,
              [baseSalary]: i[payTax] ? false : i[baseSalary]
            };
          } else {
            return {
              ...i,
              [field[1]]: val
            };
          }
        } else {
          return {...i};
        }
      }
    );
    this.updateRecalType = value.recal;
    this.recalculate([0], true);
    this.isAutoRecalColumn = true;
  }

  onCheckboxValueChange(type: string): void {
    if (this.updateRecalType.includes(type)) {
      this.updateRecalType = this.updateRecalType.filter(i => i !== type);
    } else {
      this.updateRecalType = [...this.updateRecalType, type];
    }
  }

  confirmItaxCal(): void {
    if (!this.autoCalColumn.includes(CalType.wht)) {
      this.updateRecalType = [...this.updateRecalType, RecalType.withholdingTax];
    }
    this.recalculate([0], true);
    this.modalRef.hide();
  }

  cancelItaxcal(): void {
    this.modalRef.hide();
  }

  checkListAutocal(): any[] {
    return this.autocalCheckboxList.filter(i => this.autoCalColumn.includes(i.labelEn));
  }

  onAddSelectedEmployeeToPayroll({employeeIdList, forceSave}): void {
    const body = {
      companyId: this.companyId,
      payrollId: this.payrollId,
      employees: employeeIdList,
      incomeColumns: this.incomeColumnsNoFormat,
      expenseColumns: this.expenseColumnsNoFormat
    };
    this.selectedEmployee = employeeIdList;
    this.companyService.addMoreEmployeeToPayroll(body).pipe(
      takeUntil(this.destroy$)
    ).subscribe((response: any) => {
      const action = () => {
        if (response.success) {
          response.employees?.map(item => {
            // this.employeeList = this.employeeList?.length > 0 ? this.sortEmployee([...this.employeeList, item]) : [item];
            this.employeeCurrent = this.employeeCurrent?.length > 0
              ? this.employeeCurrent.filter(emp => emp.employee_id !== item.employee_id) : [];
            this.employeeOld = this.employeeOld?.length > 0 ? this.employeeOld.filter(emp => emp.employee_id !== item.employee_id) : [];
          });
          this.resetEmployeeDatas();
          this.employeeRemoved = this.employeeRemoved.filter(item => !employeeIdList.includes(item));
          this.getCompletedPayrollDetailByMonth(this.payrollId, this.filters);
        }
      };
      if (forceSave) {
        this.savePayroll(action, response.employees);
      } else {
        this.openSaveModal(action, response.employees);
      }
    });
  }

  goBack(): void {
    const snapshotFilters: Params = this.route.snapshot.queryParams;
    const qs: Keypair = {...snapshotFilters};
    delete qs.status;
    delete qs.payrollId;
    delete qs.month;
    delete qs.started;
    this.router.navigate(['../'], {relativeTo: this.route, queryParams: qs});
    this.canRedirect = true;
  }

  removeFormCurrentList(employeeId: string): void {
    const removedIndex = this.employeeList.findIndex(item => item.employee_id === employeeId);
    const selectedEmployee = this.employeeList[removedIndex];
    this.employeeCurrent = [...this.employeeCurrent, selectedEmployee];
    this.employeeList = this.employeeList.filter(item => item.employee_id !== employeeId);
    this.resetEmployeeDatas();
    // Keep auto recal style
    this.expenseHasChanged = this.expenseHasChanged.filter(item => item.row !== removedIndex).map(item => {
      item.row = item.row > removedIndex ? --item.row : item.row;
      return item;
    });
    this.employeeRemoved = [...this.employeeRemoved, employeeId];
    this.checkModalOpened(employeeId);
  }

  removeFormCurrentListToOld(employeeId: string): void {
    const removedIndex = this.employeeList.findIndex(item => item.employee_id === employeeId);
    const selectedEmployee = this.employeeList[removedIndex];
    this.employeeOld = [...this.employeeOld, selectedEmployee];
    this.employeeList = this.employeeList.filter(item => item.employee_id !== employeeId);
    this.resetEmployeeDatas();
    // Keep auto recal style
    this.expenseHasChanged = this.expenseHasChanged.filter(item => item.row !== removedIndex).map(item => {
      item.row = item.row > removedIndex ? --item.row : item.row;
      return item;
    });
    this.employeeRemoved = [...this.employeeRemoved, employeeId];
    this.checkModalOpened(employeeId);
  }

  checkModalOpened(employeeId): void {
    if (this.state === 'open' && +employeeId === +this.employeeId) {
      this.state = 'default';
      this.state === 'open' ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'initial');
    }
  }

  onViewProfile(): void {
    this.actionName = 'gotoFullProfile';
    this.gotoFullProfile();
  }

  gotoFullProfile(): void {
    const qs: Keypair = {};
    qs.employeeId = this.employeeId;
    qs.companyId = this.companyId;
    qs.year = this.year;
    this.router.navigate(['/payroll/employee'], {relativeTo: this.route, queryParams: qs, fragment: 'profile'});
  }

  checkWhtColumnNoChanged(): void {
    if (this.canAutocal && this.expenseHasChanged.length > 0 && this.expenseHasChanged.find(item => item.name === CalType.wht)) {
      const index = this.expenditureColumnsHeader.findIndex(item => item.labelEn === CalType.wht);
      this.expenseHasChanged = this.expenseHasChanged.map(item => item.name === CalType.wht ? {...item, col: index} : {...item});
    }
  }

  onNoRecalWht(value: boolean): void {
    this.setNocalWht = true;
  }

  checkEmployeeHasAutoCal(): void {
    if (this.canAutocal) {
      this.employeeList.map((item, index) => {
        if (item.auto_calculated_column) {
          item.auto_calculated_column.map(column => {
            if (!this.autoCalColumn.includes(column)) {
              this.autoCalColumn = [...this.autoCalColumn, column];
            }
            this.onTableValueChangedAndSetDataAndStyle({
              row: index,
              col: column === CalType.wht ? this.expenditureColumnsHeader.findIndex(item => item.labelEn === CalType.wht)
                : this.expenditureColumns.indexOf(column),
              value: +this.employeeList.find(i => i.employee_id === item.employee_id).expense[column] === 0 && column !== CalType.wht ? ''
                : +this.employeeList.find(i => i.employee_id === item.employee_id).expense[column],
              name: column,
              styleChanged: true
            }, expenseHasChanged);
          });
        } else {
          if (this.expenseHasChanged.find(i => i.row === index)) {
            this.expenseHasChanged.filter(i => i.row === index).map(data => {
              Object.keys(this.employeeList[index].expense).map(column => {
                if (data.name === column) {
                  this.onTableValueChangedAndSetDataAndStyle({
                    row: index,
                    col: data.col,
                    value: +this.employeeList[index].expense[column] === 0 && column !== CalType.wht ? ''
                      : +this.employeeList[index].expense[column],
                    name: data.name,
                    styleChanged: false
                  }, expenseHasChanged);
                }
              });
            });
          }
        }
      });
    }
  }

  resetEmployeeDatas(): void {
    this.incomeColumnsData = this.employeeList.map(item => this.formatColumnData(item, this.incomeColumns, INCOME));
    this.expenditureColumnsData = this.employeeList.map(item => this.formatColumnData(item, this.expenditureColumns, EXPENSE));
    this.recalculateTotal();
    if (this.selectedEmployee.length > 0) {
      this.add();
    }
    this.extendData = this.formatExtendData();
  }

  add(): void {
    if (this.canAutocal) {
      this.checkEmployeeHasAutoCal();
      this.selectedEmployee = [];
    }
  }

  sortEmployee(employeeList: any[]): any[] {
    const fullTime = employeeList ?
      employeeList.filter(item => item.employment_type !== this.partTime).sort((a, b) => +a.employee_id - +b.employee_id) : [];
    const partTime = employeeList ?
      employeeList.filter(item => item.employment_type === this.partTime).sort((a, b) => +a.employee_id - +b.employee_id) : [];
    return [...fullTime, ...partTime];
  }

  onSetFilterEmployee(value: string) {
    const action = () => {
      this.searchName = value;
      this.filters = { ...this.filters, ...{name: this.searchName}};
      this.page = 1;
      this.getCompletedPayrollDetailByMonth(this.payrollId, this.filters);
    }
    this.doSaveEmployeeCaches(action);
  }

  onPageChange(): void {
    const action = () => {
      this.getCompletedPayrollDetailByMonth(this.payrollId, this.filters);
    }
    this.doSaveEmployeeCaches(action);
  }

  onFilterChanged(val: any): void {
    const action = () => {
      this.filters = { ...this.filters, ...val};
      this.page = 1;
      this.getCompletedPayrollDetailByMonth(this.payrollId, this.filters);
    }
    this.doSaveEmployeeCaches(action);
  }

  doSaveEmployeeCaches(nextActionFunc: any): void {
    if (this.employeeCaches?.length >= 1000) {
      this.openSaveModal(nextActionFunc);
    } else {
      if (nextActionFunc) {
        nextActionFunc();
      }
    }
  }

  savePayroll(nextActionFunc: any, specialEmployees: any = null): void {
    const listObs = this.createSaveObs(specialEmployees);
    listObs.pipe(
      takeUntil(this.destroy$)
    ).subscribe((response: IResponse[]) => {
      let success = true;
      response.forEach(res => {
        if (!res.success) {
          success = false;
        }
      });
      if (success) {
        if (nextActionFunc) {
          nextActionFunc();
          this.doUnSave();
        }
      }
    });
  }

  openSaveModal(nextActionFunc: any, specialEmployees: any = null): void {
    this.modalRef = this.modalService.show(LeavePageConfirmModalComponent, {backdrop: 'static', class: 'custom-modal'});
    this.modalRef.content.onClose.subscribe(result => {
      if (result) { // case: save
        this.savePayroll(nextActionFunc, specialEmployees);
      } else {
        // Don't save: do nothing
        // this.doUnSave();
      }
    });
  }

  doUnSave(): void {
    this.employeeTempList = [];
    this.isAutoRecalColumn = false;
    this.employeeCaches = [];
    this.expenseHasChanged = [];
  }

  removeSpecialExtendColumns(columns: any, isObject: boolean): any {
    if (isObject) {
      return columns.filter(o => !SpecialExtendColumns.includes(o.name))
    } else {
      return columns.filter(o => !SpecialExtendColumns.includes(o))
    }
  }

  addSpecialExtendColumns(columns: any, isObject: boolean): any {
    columns = this.removeSpecialExtendColumns(columns, isObject)
    let order = 1
    let extendColumns = columns.flatMap(item => {
      if (isObject) {
        item.order = order++
      }
      let name = isObject ? item.name : item
      let specialColumn = SpecialColumnPayroll.find(o => o.name == name)
      if (specialColumn && specialColumn.list) {
        let extraCol = []
        specialColumn.list.map((c: any) => {
          let obj = isObject ? {...c, name: c.label, order: order++} : c.label
          extraCol.push(obj)
        })
        return [item, ...extraCol]
      }  
      return item
    })
    return extendColumns
  }

  onExport(): void {
    const action = () => {
      this.selectedReportOption = null
      this.openModal(this.confirmReportModal)
    }
    this.openSaveModal(action)
  }

  onReportOptionChanged(e: any): void {
    this.selectedReportOption = e
  }

  downloadReport(): void {
    if (this.selectedReportOption) {
      if (this.modalRef) {
        this.modalRef.hide();
      }
      this.getPDFFile(`${environment.apiBaseUrl}/companies/${this.companyId}/payroll/${this.payrollId}/${this.selectedReportOption}/excelreport`);
    }
  }

  getPDFFile(url: string): void {
    this.openModal(this.progressModal);
    this.eventService
      .getServerSentEvent(url)
      .subscribe((response: any) => {
          if (response.type === 'url') {
            this.percentage = 100;
            this.download(response.data);
          } else if (response.type === 'error') {
            alert(
              `Error while getting file import progress: ${response.data}`,
            );
            this.modalRef.hide();
          } else {
            if (response.data !== 'connecting') {
              this.percentage = +response.data;
            }
          }
        },
        (error) => {
          console.log(
            `Error while getting file import progress: ${error}`,
          );
        });
  }

  download(file: string): void {
    const downloadLink = document.createElement('a');
    downloadLink.href = file;
    downloadLink.target = '_blank';
    downloadLink.setAttribute('download', file);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    setTimeout(() => {
      document.body.removeChild(downloadLink);
      if (this.modalRef) {
        this.modalRef.hide();
      }
      this.percentage = 0;
    }, 1000);
  }

}
